module.exports = __webpack_public_path__ + "static/media/headphones.972c670c.svg";